import $ from 'jquery';

$(document).ready(function(){

  $('.js-expand').on('click', function(e){
    e.preventDefault();
    $(this).siblings('.iaec__expandable-copy').toggleClass('open');
    $(this).find('span').toggleClass('hidden');
  });

});